<template>
    <div v-loading="loading">
        <div class="header-btn">
            <el-button size="small" type="warning" @click="openCreate" icon="el-icon-plus"></el-button>
        </div>

        <el-table
                fit
                stripe
                class="data-table"
                :data="data">
            <el-table-column
                    header-align="center"
                    align="center"
                    v-for="item in [
                        {prop:'name',label:'Name'},
                        {prop:'email',label:'Email'},
                        {prop:'mobile',label:'Mobile'},
                        {prop:'status',label:'Status',fmt:statusFmt},
                        {prop:'updateTime',label:'Updated Time',fmt:selfTimeFormat},
                    ]"
                    :formatter="item.fmt"
                    :prop="item.prop"
                    :label="item.label"
                    :key="item.label">
            </el-table-column>

            <el-table-column
                    header-align="center"
                    align="center"
                    label="Action">
                <template slot-scope="s">
                    <el-button :type="s.row.status===2?'success':'warning'" @click="updateStatus(s.row.id)" size="mini"
                               :disabled="currentUid === s.row.id">{{s.row.status===2?'Active':'InActive'}}
                    </el-button>

                    <el-button type="danger" @click="deleteData(s.row.id)" size="mini"
                               :disabled="currentUid === s.row.id">
                        Delete
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="page">
            <el-pagination v-if="page.total>1"
                           @current-change="loadData"
                           :page-size="page.size"
                           :current-page.sync="page.page"
                           :page-count="page.totalPage"
                           layout="prev, pager, next"
                           :total="data.total">
            </el-pagination>
        </div>

        <el-dialog
                v-if="dialogVisible"
                center
                :close-on-click-modal="false"
                :visible.sync="dialogVisible"
                width="700px">
            <el-form ref="form" :model="form" :rules="rules" label-width="100px" label-position="left">
                <el-form-item prop="name" label="Name">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>

                <el-form-item prop="icNumber" label="IC Number">
                    <el-input v-model="form.icNumber"></el-input>
                </el-form-item>

                <el-form-item prop="mobile" label="Mobile">
                    <el-input v-model="form.mobile"></el-input>
                </el-form-item>

                <el-form-item v-if="!isCreate" prop="email" label="Email">
                    <el-input v-model="form.email"></el-input>
                </el-form-item>

                <el-form-item prop="password" label="Password">
                    <el-input v-model="form.password"></el-input>
                </el-form-item>

                <el-form-item prop="gender" label="Gender">
                    <el-select v-model="form.gender" placeholder="Select gender">
                        <el-option
                                v-for="item in [{value:1,label:'Male'},{value:2,label:'Female'}]"
                                :key="item.label"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                 <el-button @click="dialogVisible = false">Cancel</el-button>
                 <el-button type="primary" @click="saveData">Save</el-button>
             </span>
        </el-dialog>

    </div>
</template>

<script>
    import {employeesList, employeeCreate, employeeUpdate, employeeUpdateStatus, deleteEmployee} from '@/api/VendorAPI'

    import {store} from '@/store/index'
    import {mapGetters} from "vuex";

    export default {
        name: 'Employee',
        data() {
            return {
                loading: false,
                isCreate: false,
                data: [],
                page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0},
                editId: -1,
                dialogVisible: false,
                form: {},
                rules: {}
            }
        }, computed: mapGetters({
            currentUid: 'getUid'

        }),
        methods: {
            loadData() {
                this.$pageUtils(this, employeesList);
            },
            openCreate() {
                this.isCreate = true
                this.dialogVisible = true
            },
            statusFmt(row, cell, val) {
                const status = {
                    1: 'Active',
                    2: 'InActive',
                    3: 'Pending Verification',
                }
                return status[val]
            },
            updateStatus(id) {
                employeeUpdateStatus(id)
                    .then(() => this.loadData());
            },
            deleteData(id) {
                this.$deleteRequest(this, deleteEmployee, id)
            },
            saveData() {
                const action = this.form.id ? employeeUpdate : employeeCreate;
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        action(this.form)
                            .then(() => {
                                this.loadData()
                                this.dialogVisible = false
                            })
                    }
                })
            }
        },
        mounted() {
            this.loadData()
        }
    }
</script>

<style scoped>
    .el-button {
        margin-right: 5px;
    }

</style>
